import React from 'react';
import { MapPin, Phone, Mail, ArrowUp, Facebook } from 'lucide-react';

const Footer = () => {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const navLinks = [
    { label: 'Inicio', id: 'inicio' },
    { label: 'Sobre nosotros', id: 'nosotros' },
    { label: 'Servicios', id: 'servicios' },
    { label: 'Proyectos', id: 'proyectos' },
    { label: 'Contacto', id: 'contacto' },
  ];

  const services = [
    'Construcción de Vivienda',
    'Obra Pública y Privada',
    'Remodelaciones',
    'Pavimentación',
    'Conservación y Mantenimiento',
    'Revestimiento y Acabados',
  ];

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer style={{
      background: '#080808',
      borderTop: '1px solid rgba(255,255,255,0.06)',
    }}>
      {/* Main Footer */}
      <div style={{
        maxWidth: 1200,
        margin: '0 auto',
        padding: '5rem 2rem 3rem',
        display: 'grid',
        gridTemplateColumns: '2fr 1fr 1fr 1fr',
        gap: '3rem',
      }} className="footer-grid">

        {/* Brand */}
        <div>
          {/* Logo */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '1.5rem' }}>
            <div style={{
              width: 44,
              height: 44,
              background: 'var(--red)',
              borderRadius: 8,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
              <span style={{
                fontFamily: 'var(--font-heading)',
                fontWeight: 900,
                fontSize: '1.3rem',
                color: 'white',
              }}>Y</span>
            </div>
            <div>
              <div style={{
                fontFamily: 'var(--font-heading)',
                fontWeight: 800,
                fontSize: '1rem',
                color: 'white',
                letterSpacing: '0.15em',
                textTransform: 'uppercase',
              }}>YESCAS</div>
              <div style={{
                fontFamily: 'var(--font-heading)',
                fontWeight: 300,
                fontSize: '0.6rem',
                color: 'rgba(255,255,255,0.4)',
                letterSpacing: '0.25em',
                textTransform: 'uppercase',
              }}>GRUPO CONSTRUCTOR</div>
            </div>
          </div>

          <p style={{
            fontFamily: 'var(--font-body)',
            fontSize: '0.875rem',
            color: 'rgba(255,255,255,0.8)',
            lineHeight: 1.8,
            marginBottom: '1.5rem',
            maxWidth: 300,
          }}>
            Empresa oaxaqueña especializada en obra pública y privada con más de 12 años de experiencia y 200+ proyectos completados.
          </p>

          {/* Social */}
          <div style={{ display: 'flex', gap: '0.75rem' }}>
            <a
              href="https://www.facebook.com/yescasgrupoconstructor/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                width: 38,
                height: 38,
                background: 'rgba(255,255,255,0.06)',
                border: '1px solid rgba(255,255,255,0.1)',
                borderRadius: 8,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'rgba(255,255,255,0.5)',
                transition: 'background 0.3s ease, color 0.3s ease, border-color 0.3s ease',
                textDecoration: 'none',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'var(--red)';
                e.currentTarget.style.color = 'white';
                e.currentTarget.style.borderColor = 'var(--red)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.06)';
                e.currentTarget.style.color = 'rgba(255,255,255,0.5)';
                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)';
              }}
            >
              <Facebook size={16} />
            </a>
          </div>
        </div>

        {/* Navigation */}
        <div>
          <h4 style={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 700,
            fontSize: '0.75rem',
            letterSpacing: '0.2em',
            textTransform: 'uppercase',
            color: 'rgba(255,255,255,0.75)',
            marginBottom: '1.25rem',
          }}>Navegación</h4>
          <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
            {navLinks.map((link) => (
              <li key={link.id}>
                <button
                  onClick={() => scrollTo(link.id)}
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontFamily: 'var(--font-body)',
                    fontSize: '0.875rem',
                    color: 'rgba(255,255,255,0.85)',
                    padding: 0,
                    transition: 'color 0.2s ease',
                    textAlign: 'left',
                  }}
                  onMouseEnter={(e) => e.target.style.color = 'var(--red)'}
                  onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.85)'}
                >
                  {link.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div>
          <h4 style={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 700,
            fontSize: '0.75rem',
            letterSpacing: '0.2em',
            textTransform: 'uppercase',
            color: 'rgba(255,255,255,0.75)',
            marginBottom: '1.25rem',
          }}>Servicios</h4>
          <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
            {services.map((s, i) => (
              <li key={i}>
                <button
                  onClick={() => scrollTo('servicios')}
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontFamily: 'var(--font-body)',
                    fontSize: '0.875rem',
                    color: 'rgba(255,255,255,0.85)',
                    padding: 0,
                    transition: 'color 0.2s ease',
                    textAlign: 'left',
                  }}
                  onMouseEnter={(e) => e.target.style.color = 'var(--red)'}
                  onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.85)'}
                >
                  {s}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 style={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 700,
            fontSize: '0.75rem',
            letterSpacing: '0.2em',
            textTransform: 'uppercase',
            color: 'rgba(255,255,255,0.75)',
            marginBottom: '1.25rem',
          }}>Contacto</h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {[
              { icon: MapPin, text: 'Geranios No. 302, Col. Las Flores Sur, Santa Lucía del Camino, Oaxaca.' },
              { icon: Phone, text: '951 502 62 20 · 951 499 79 59' },
              { icon: Mail, text: 'grupoconstructoryescas@hotmail.com' },
            ].map((item, i) => (
              <div key={i} style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                <item.icon size={14} color="var(--red)" strokeWidth={1.5} />
                <span style={{
                  fontFamily: 'var(--font-body)',
                  fontSize: '0.85rem',
                  color: 'rgba(255,255,255,0.8)',
                }}>{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div style={{
        borderTop: '1px solid rgba(255,255,255,0.06)',
        padding: '1.25rem 2rem',
        maxWidth: 1200,
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '1rem',
      }}>
        <p style={{
          fontFamily: 'var(--font-body)',
          fontSize: '0.8rem',
          color: 'rgba(255,255,255,0.65)',
        }}>
          © 2025 Grupo Constructor Yescas. Todos los derechos reservados.
        </p>

        <button
          onClick={scrollTop}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            background: 'none',
            border: '1px solid rgba(255,255,255,0.15)',
            borderRadius: 6,
            padding: '0.4rem 0.875rem',
            cursor: 'pointer',
            fontFamily: 'var(--font-heading)',
            fontWeight: 600,
            fontSize: '0.7rem',
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            color: 'rgba(255,255,255,0.75)',
            transition: 'border-color 0.3s ease, color 0.3s ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = 'var(--red)';
            e.currentTarget.style.color = 'var(--red)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = 'rgba(255,255,255,0.15)';
            e.currentTarget.style.color = 'rgba(255,255,255,0.75)';
          }}
        >
          <ArrowUp size={13} /> Volver arriba
        </button>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .footer-grid { grid-template-columns: 1fr 1fr !important; }
        }
        @media (max-width: 480px) {
          .footer-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
